import type { ClinicalEpisode, ClinicalSubject } from './types';
/** RFC 4122 UUIDv5, matching Python uuid.uuid5(UUID(fetus_id), 'newborn'). */
export async function newbornSubjectId(fetusId: string): Promise<string> {
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(fetusId))
    throw new Error('Invalid fetus identity');
  const namespace = Uint8Array.from(fetusId.replaceAll('-', '').match(/../g)!, (v) => parseInt(v, 16));
  const name = new TextEncoder().encode('newborn');
  const bytes = new Uint8Array(namespace.length + name.length);
  bytes.set(namespace);
  bytes.set(name, namespace.length);
  const hash = new Uint8Array(await crypto.subtle.digest('SHA-1', bytes)).slice(0, 16);
  hash[6] = (hash[6] & 15) | 80;
  hash[8] = (hash[8] & 63) | 128;
  const hex = Array.from(hash, (v) => v.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
export async function withNewbornSubjects(episode: ClinicalEpisode): Promise<ClinicalEpisode> {
  const subjects: ClinicalSubject[] = episode.subjects.map((s) => ({ ...s }));
  for (const fetus of episode.subjects.filter((s) => s.subject_type === 'FETUS')) {
    const id = fetus.newborn_subject_id ?? (await newbornSubjectId(fetus.id));
    const existing = subjects.find((s) => s.id === id);
    if (existing) existing.fetus_subject_id = fetus.id;
    else
      subjects.push({
        id,
        subject_type: 'NEWBORN',
        label: `Newborn — ${fetus.label}`,
        active: fetus.active,
        fetus_subject_id: fetus.id,
      });
  }
  return { ...episode, subjects };
}
